import Portfolio from "../../../commonComponents/portfolio";

const PortfolioTransformContainer = () => {
  return <Portfolio type="transform" gridSize={3} carShow={9} />;
};

export default PortfolioTransformContainer;
